<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      class="suggestions-filter"
      :disabled="disabled"
      :options="data"
      v-model="data_id"
      :reduce="reduce"
      :filterBy="filterByUsers"
      :placeholder="placeholder"
      label="name"
      @search="debouncedFetchData">
      <template slot="no-options">
        <template v-if="!emptyResults">Trwa wyszukiwanie&hellip;</template>
        <template v-if="emptyResults">Brak wyników pasujących do podanej frazy&hellip;</template>
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center" v-if="valueSearch === ''">
          {{ option.name }} {{ option.last_name }}
        </div>
        <div class="form-group" v-else>
          <div class="d-center drop-name">
            {{ option.name }} {{ option.last_name }}
          </div>
          <div class="d-center">
            <label> Numer pesel:</label>
            {{ option.pesel }}
          </div>
          <div class="d-center">
            <label> Numer telefonu:</label>
            {{ option.phone }}
          </div>
          <div class="d-center">
            <label> Adres e-mail:</label>
            {{ option.email }}
          </div>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.name }} {{ option.last_name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';

export default {
  name: 'patient-suggestion-filter',
  props: {
    dataId: {
      type: [String, Number],
      required: true
    },
    endpointItems: {
      type: String,
      required: true
    },
    endpointItem: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    reduce: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data_id (data) {
      this.emitFilterResult(data);
      if (data === '') {
        this.valueSearch = ''
      }
    }
  },
  data () {
    return {
      data_id: '',
      data: [],
      emptyResults: false,
      valueSearch: ''
    }
  },
  mounted () {
    this.data_id = this.dataId;
    if (this.data_id) {
      this.prefetchData(this.data_id);
    } else {
      this.data_id = '';
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItems,
        outputKey: 'data'
      });
    }
  },
  methods: {
    emitFilterResult(data) {
      this.$emit('input', data)
    },
    filterByUsers (option, label, search) {
      this.valueSearch = search;
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1 || option.pesel;
    },
    prefetchData (patientID) {
      if (!patientID) {
        return;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItem + parseInt(patientID, 10),
        outputKey: 'data',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.data_id = parseInt(patientID, 10);
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);
      let endpointUrl = this.endpointItems;
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.data_id !== 0 && this.data_id !== '' && searchPhrase === '') {
        endpointUrl = this.endpointItem + parseInt(this.data_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'data',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }
          loadingCallback(false);
        }
      });
    },
    debouncedFetchData: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/patient-suggestion-filter.scss";
</style>
